import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { CountryModel } from "src/app/models/common/countrymodel";
import { BackendListModel } from "src/app/models/common/list.model";
import { RegionModel } from "src/app/models/common/region";
import { ApiRoutes } from "src/app/services/apiroutes";
import { GeoApiService } from "src/app/services/domain_code/geo-api.service";

@Component({
    selector: 'logzy-region-form',
    templateUrl: './region-form.component.html',
    styleUrls: ['./region-form.component.scss', '../master-data.scss',
    ]
})

export class RegionFormComponent implements OnInit {

    region_url = ApiRoutes.Geo;
    continents = ['asia', 'africa', 'australia', 'europe', 'north-america', 'south-america'];
    countryList: BackendListModel<CountryModel>;

    @Input()
    errorObj: any = {};

    @Output()
    closeForm = new EventEmitter<RegionModel>();

    constructor(private geoService: GeoApiService, private snackBar: MatSnackBar) { }

    @Input()
    regionObject: RegionModel;

    defaultRegion: RegionModel = {
        id: null,
        updated_at: null,
        created_at: null,
        is_active: true,
        name: null,
        description: null,
        logo_id: 'asia',
        logo_url: null,
        type: null,
        countries: []
    }

    ngOnInit() {
        this.resetComponent();
        this.getCountries();
    }

    resetComponent() {
        this.errorObj = {}
        this.regionObject = { ...this.defaultRegion };
    }

    getCountries() {
        this.geoService.getCountriesMappedInRegion().subscribe({
            next: response => {
                this.countryList = response
                console.log("countryList", this.countryList);
            },
            error: error => {
                console.log(error)
                return error;
            }
        })
    }

    // Function to catch errors
    catchError(error) {
        if (error.status >= 500) {
            this.errorObj = { ...error.error };
            return error;
        } else if (error.status > 399 && error.status < 500) {
            this.errorObj = { ...error.error };
            return error;
        }
    }

    postRegionData(data) {
        this.geoService.postRegion(data).subscribe({
            next: response => {
                this.snackBar.open("Region Added Successfully!", 'Close', {
                    verticalPosition: 'top',
                    duration: 2000,
                });
                this.closeRegionForm(response);
                this.getCountries();
                return response;
            },
            error: error => {
                return this.catchError(error);
            }
        })
    }

    putRegionData(id, data) {
        this.geoService.updateRegion(id, data).subscribe({
            next: response => {
                this.snackBar.open("Region Updated Successfully!", 'Close', {
                    verticalPosition: 'top',
                    duration: 2000,
                });
                this.closeRegionForm(response);
                this.getCountries();
                return response;
            },
            error: error => {
                return this.catchError(error);
            }
        })
    }

    filterRegionData() {
        let data = { ...this.regionObject };
        data.countries = this.getIdListFromObjList(data.countries);
        console.log("data", data)
        return data;
    }

    getIdListFromObjList(objList: any[]) {
        let objIds = []
        for (let obj of objList) {
            objIds.push(obj.id);
        }
        return objIds;
    }

    onRegionSave() {
        let payload = this.filterRegionData();
        if (payload.id != null) {
            this.putRegionData(payload.id, payload);
        } else {
            this.postRegionData(payload);
        }
    }

    editRegionMaster(element) {
        this.regionObject = JSON.parse(JSON.stringify(element));
    }

    closeRegionForm(regionObject: any) {
        this.resetComponent();
        this.closeForm.emit(regionObject);
    }
}